import GlSegmentSelect from '../../components/gl-segment-select';
import { GL_FACILITY, isSegmentOverridden, segmentRuleOf, withSegmentChoice, withSegmentRule } from '../../utils/gl-segment-rules';

/** Display the server's resolution; only unresolved or manually chosen values are editable. */
export default function ReviewFacilityField({ preview, data, onChange }) {
  const read = key => data.t.read(`segment_rules.${key}`);
  const label = data.t.read('gl_segment.facility');
  if (preview.pending) return <div role="status">{read('review_loading')}</div>;
  if (preview.error) return <div role="alert">{read('review_error')} <button type="button" className="btn btn-link" onClick={preview.retry}>{read('retry')}</button></div>;
  const line = preview.line || {};
  const rule = segmentRuleOf(line, GL_FACILITY);
  const editable = rule?.must_choose || isSegmentOverridden(line, GL_FACILITY) || preview.issues?.length > 0;
  const value = line[GL_FACILITY];
  const options = preview.options || rule?.options || [];
  if (!editable && !value) return null;
  return <div className="d-flex pb-2">
    <span className="report-label col-2">{label}</span>
    <div className="col-8 mb-2">
      {editable ? <>
        <GlSegmentSelect segment={GL_FACILITY} value={value} ariaLabel={label} placeholder={read('choose_placeholder')}
          allowedCodes={options} isDisabled={!options.length} compact onChange={picked => onChange(withSegmentChoice(line, GL_FACILITY, picked))} />
        {isSegmentOverridden(line, GL_FACILITY) && <button type="button" className="btn btn-link p-0"
          onClick={() => onChange(withSegmentRule(line, GL_FACILITY))}>{read('line_use_rule')}</button>}
        {preview.issues?.length > 0 && <div role="alert">{read(options.length ? 'review_choose' : 'review_no_options')}</div>}
      </> : <span>{typeof value === 'object' ? value.name || value.code : value}</span>}
    </div>
  </div>;
}
